import {
  Header,
  Box,
  Badge,
  SpaceBetween,
  Spinner,
  Alert,
  Container
} from "@cloudscape-design/components";
import { useEffect, useState } from "react";
import { organizationService } from "../services/organizationService";
import OrganizationCard from "../components/organizations/OrganizationCard";

const Organizations = () => {
  const [organizations, setOrganizations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchOrganizations = async () => {
    try {
      const data = await organizationService.getOrganizations();
      setOrganizations(Array.isArray(data) ? data : []);
      setError(null);
    } catch (error) {
      setError("Failed to load organizations. Please try again later.");
      setOrganizations([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrganizations();
  }, []);

  return (
      <SpaceBetween size="l">
        <Header variant="h2">
          Organizations {!loading && <Badge color="blue">{organizations.length}</Badge>}
        </Header>

        {error && (
          <Alert type="error">
            {error}
          </Alert>
        )}

        {loading ? (
          <Container>
            <SpaceBetween size="m">
              <Spinner size="large" />
              <Box color="text-status-info" fontSize="heading-s">
                Loading organizations...
              </Box>
            </SpaceBetween>
          </Container>
        ) : !error && organizations.length === 0 ? (
          <Container>
            <Box textAlign="center" color="text-status-inactive" fontSize="heading-s">
              No organizations found.
            </Box>
          </Container>
        ) : (
          organizations.map((org) => (
            <div key={org.id} className="clickable">
              <OrganizationCard
                organization={org}
              />
            </div>
          ))
        )}
      </SpaceBetween>
  );
};

export default Organizations;